var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnicargoAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1426 1.97656L22.1609 2.31792L16.9462 6.636L12.8134 5.90641L9.21346 5.2683L5.89942 4.67994L3.6346 6.61027L12.8677 10.8477L7.34431 17.569C7.19851 17.7142 7.06585 17.8583 6.94921 18.0013L3.49852 16.5993L1.85693 18.2409L5.54663 19.9316L5.70159 20.0866L4.5363 21.3662L5.06862 21.8511L6.21104 20.596L6.65703 21.0414L8.2117 24.0233L9.73321 22.4989L7.9584 18.9893C8.04874 18.9264 8.13623 18.8572 8.21456 18.776L15.3813 13.1457L15.4779 13.2418L20.2951 22.7957L21.9876 20.7676L21.2963 17.2271L20.6062 13.6895L19.6953 9.02547L19.6673 8.99574L23.6829 4.18821L24.1426 1.97656Z",
    fill: "#1D4650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicargoAirplane);
export default __webpack_public_path__ + "static/media/unicargo-airplane.0976e02a572cf668a668e3fae92e0112.svg";
export { ForwardRef as ReactComponent };